/**
 * DevExtreme (esm/common/data/query_implementation.js)
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import arrayQueryImpl from "./array_query";
import remoteQueryImpl from "./remote_query";
export const queryImpl = {
  array: arrayQueryImpl,
  remote: remoteQueryImpl
};